var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height",attrs:{"no-gutters":"","align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"size":60,"width":5,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }